import styled, { css } from "styled-components";
import { AlignmentEnum } from "../../../types/AppTypes";

type StyledDoubleStructureProps = {
  $variant?: string;
  $verticalAlignment: AlignmentEnum;
  $wrap?: "start" | "end";
};

/* new variants */

const variantStyles = (variant = "primary") =>
  ({
    primary: css`
      justify-content: space-between;
    `,
    secondary: css`
      justify-content: flex-start;
    `,
    tertiary: css`
      justify-content: flex-end;
    `,
  })[variant];

const StyledDoubleStructure = styled.div<StyledDoubleStructureProps>`
  ${({ $variant: variant }) => variantStyles(variant)};
  display: flex;
  flex-direction: row;
  align-items: ${({ $verticalAlignment }) => $verticalAlignment};
  width: 100%;
  gap: 20px;
  flex-wrap: ${({ $wrap }) => ($wrap !== undefined ? "wrap" : "unset")};

  ${({ $wrap = "start", $variant }) =>
    $wrap === "end" &&
    ($variant === "primary" || $variant === "tertiary") &&
    css`
      & > :last-child {
        margin-left: auto;
      }
    `}
  @media (max-width: ${({ theme }) => theme.breakpoints.SM}px) {
    flex-wrap: wrap;
  }
`;

export { StyledDoubleStructure };
